export default __webpack_public_path__ + "static/media/target-9@2x.47d386bb.png";